import { API_BASE_URL } from './config';
import { apiFetch } from './apiFetch';

export type SessionStatus = 'pending' | 'in_progress' | 'completed' | 'expired';

export type AssessmentSessionDto = {
  id: string;
  companyId: string;
  templateId: string;
  templateName: string | null;
  assignedToUserId: string;
  assignedByUserId: string | null;
  status: SessionStatus;
  dueDate: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type SessionResponseItem = {
  sectionId: string;
  questionKey: string;
  responseValue: unknown;
  score?: number;
};

export async function listSessionsForCompany(
  companyId: string,
  options?: { userId?: string; status?: SessionStatus },
) {
  const params = new URLSearchParams();
  if (options?.userId) params.set('userId', options.userId);
  if (options?.status) params.set('status', options.status);

  const res = await apiFetch(
    `${API_BASE_URL}/api/assessment-sessions/company/${companyId}?${params.toString()}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { sessions: AssessmentSessionDto[] }; error?: string }>;
}

export async function listMySessions(userId: string, companyId: string) {
  const res = await apiFetch(
    `${API_BASE_URL}/api/assessment-sessions/my/${userId}?companyId=${companyId}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { sessions: AssessmentSessionDto[] }; error?: string }>;
}

export async function getSession(sessionId: string) {
  const res = await apiFetch(
    `${API_BASE_URL}/api/assessment-sessions/${sessionId}`,
    { headers: { 'Content-Type': 'application/json' } },
  );
  return res.json() as Promise<{ success: boolean; data?: { session: AssessmentSessionDto }; error?: string }>;
}

export async function assignSession(
  input: {
    companyId: string;
    templateId: string;
    assignedToUserId: string;
    assignedByUserId?: string;
    dueDate?: string;
  },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/assessment-sessions/assign`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { session: AssessmentSessionDto }; error?: string }>;
}

export async function startSession(sessionId: string, userId: string) {
  const res = await apiFetch(`${API_BASE_URL}/api/assessment-sessions/${sessionId}/start`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId }),
  });
  return res.json() as Promise<{ success: boolean; data?: { session: AssessmentSessionDto }; error?: string }>;
}

export async function submitSession(
  sessionId: string,
  input: { userId: string; companyId: string; responses: SessionResponseItem[] },
) {
  const res = await apiFetch(`${API_BASE_URL}/api/assessment-sessions/${sessionId}/submit`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  return res.json() as Promise<{ success: boolean; data?: { session: AssessmentSessionDto }; error?: string }>;
}
